module.exports = __webpack_public_path__ + "img/CPTsample1-1.e66585a8.png";